import { LeaveComponent } from "../../components";

export default function LeaveApprovalPage() {
  return <LeaveComponent.LeaveApproval />;
}
